module.exports = __webpack_public_path__ + "images/twelve-year-club-2e394b5b87ac1799ec63c721bdd00b39.png";